import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import clsx from 'clsx';
import FilterListIcon from '@material-ui/icons/FilterList';
import { useStyles, useToolbarStyles } from './VisitaFiliadoTableStyles';
import Box from '@material-ui/core/Box';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControl from '@material-ui/core/FormControl';
import moment from 'moment/moment';
import StatusBullet from '../../../../components/StatusBullet';
import VisibilityIcon from '@material-ui/icons/Visibility';


function VisitaFiliadoTable(props) {
  const { visitaFiliados, deleteVisitaFiliado, editVisitaFiliado, previewVisitaFiliado, setVisitaFiliados} = props;
  moment.locale('pt-BR');
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [refreshState, setRefreshState] = useState(new Date());
  const [sortSelected, setSortSelected] = useState('0');
  const [sortType] = useState([
    {
      label: 'Nome',
      value: '0',
      isChecked: false
    },
    {
      label: 'Email',
      value: '1',
      isChecked: false
    },
    {
      label: 'CPF',
      value: '2',
      isChecked: false
    }
  ]);


  const EnhancedTableToolbar = props => {
    const classes = useToolbarStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = event => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    function onChangeSortType(event) {
      setSortSelected(event.target.value);
    }

    function onChooseSortMenu() {
      if(sortSelected === '0'){
        visitaFiliados.result = visitaFiliados.result.sort(function (a, b) {
          if (a.nome > b.nome) {
            return 1;
          }
          if (a.nome < b.nome) {
            return -1;
          }
          return 0;
        });
        setVisitaFiliados(visitaFiliados);
      }
      else if(sortSelected === '1'){
        visitaFiliados.result = visitaFiliados.result.sort(function (a, b) {
          if (a.email > b.email) {
            return 1;
          }
          if (a.email < b.email) {
            return -1;
          }
          return 0;
        });
        setVisitaFiliados(visitaFiliados);
      }
      else{
        visitaFiliados.result = visitaFiliados.result.sort(function (a, b) {
          if (a.cpfCnpj > b.cpfCnpj) {
            return 1;
          }
          if (a.cpfCnpj < b.cpfCnpj) {
            return -1;
          }
          return 0;
        });
        setVisitaFiliados(visitaFiliados);
      }
    }

    return (
      <Toolbar
        className={clsx(classes.root)}
      >
        <Typography className={classes.title} variant="h4" id="tableTitle">
          Visitas de filiados ao clube
        </Typography>
      </Toolbar>
    );
  };

  function onMouseOveRowTable(event, index) {
    visitaFiliados.result[index].on_mouse_over = true;
    setRefreshState(new Date());
  }

  function onMouseLeaveRowTable(event, index) {
    visitaFiliados.result[index].on_mouse_over = false;
    setRefreshState(new Date());
  }

  return (
    <Paper
      className={classes.root}
      elevation={3}
    >
      <EnhancedTableToolbar numSelected={0} />
      <TableContainer className={classes.containerTable}>
        <Table
          stickyHeader
          aria-label="sticky table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={'label_cpf'}
                align={'left'}
              >
                {'CPF'}
              </TableCell>
              <TableCell
                key={'label_nome'}
                align={'left'}
              >
                {'Nome'}
              </TableCell>
              <TableCell
                key={'label_data_entrada'}
                align={'left'}
              >
                {'Data entrada'}
              </TableCell>
              <TableCell
                key={'label_data_saida'}
                align={'left'}
              >
                {'Data saída'}
              </TableCell>
              <TableCell
                key={'lebale status'}
                align={'left'}
              >
                {'Status'}
              </TableCell>
              <TableCell
                key={'label_actions'}
                align={'right'}
                style={{width: '12%'}}
              >
                {''}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {visitaFiliados.result.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((visitaFiliado, index) => {
              return (
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={visitaFiliado.idVisitaFiliado}
                  onMouseOver={event => onMouseOveRowTable(event, index)}
                  onMouseLeave={event => onMouseLeaveRowTable(event, index)}
                >
                  <TableCell
                    align={'left'}
                  >
                    {visitaFiliado.filiado.cpf}
                  </TableCell>
                  <TableCell
                    align={'left'}
                  >
                    {visitaFiliado.filiado.nome}
                  </TableCell>
                  <TableCell
                    align={'left'}
                  >
                    {visitaFiliado.dataEntrada ? moment(visitaFiliado.dataEntrada).format('DD/MM/YYYY HH:mm:ss') : 'Não informado'}
                  </TableCell>
                  <TableCell
                    align={'left'}
                  >
                    {visitaFiliado.dataSaida ? moment(visitaFiliado.dataSaida).format('DD/MM/YYYY HH:mm:ss') : 'Não informado'}
                  </TableCell>
                  <TableCell>
                    <div className={classes.statusContainer}>
                      <StatusBullet
                        className={classes.status}
                        color={!visitaFiliado.visitaEncerrada ? 'success' : 'danger'}
                        size="sm"
                      />
                      {!visitaFiliado.visitaEncerrada ? 'Em andamento' : 'Encerrada'}
                    </div>
                  </TableCell>
                  <TableCell
                    align={'right'}
                    style={{width: '20%'}}

                  >
                    {!visitaFiliado.visitaEncerrada &&
                    <Box
                      component={'div'}
                      display={'inline'}
                      visibility={visitaFiliado.on_mouse_over ? 'visible' : 'hidden'}
                    >
                      <IconButton
                        aria-label="update"
                        className={classes.margin}
                        onClick={e => editVisitaFiliado(index)}
                      >
                        <EditIcon
                          color = 'action'
                          fontSize='small'
                        />
                      </IconButton>
                    </Box>
                    }
                    {!visitaFiliado.visitaEncerrada &&
                    <Box
                      component={'div'}
                      display={'inline'}
                      visibility={visitaFiliado.on_mouse_over ? 'visible' : 'hidden'}
                    >
                      <IconButton
                        aria-label="delete"
                        className={classes.margin}
                        onClick={e => deleteVisitaFiliado(index)}
                      >
                        <DeleteIcon
                          color = 'action'
                          fontSize='small'
                        />
                      </IconButton>
                    </Box>
                    }
                    {visitaFiliado.visitaEncerrada &&
                    <Box
                      component={'div'}
                      display={'inline'}
                      visibility={visitaFiliado.on_mouse_over ? 'visible' : 'hidden'}
                    >
                      <IconButton
                        aria-label="delete"
                        className={classes.margin}
                        onClick={e => previewVisitaFiliado(index)}
                      >
                        <VisibilityIcon
                          color = 'action'
                          fontSize='small'
                        />
                      </IconButton>
                    </Box>


                    }
                  </TableCell>
                </TableRow>

              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default VisitaFiliadoTable;
